import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'

// Reducers
import {
  setContactHomebotDataToInitialState,
  setContactHomebotShowModal,
  selectContactHomebotStep,
  setContactHomebotStep,
  STEPS,
  STEPS_CONST,
} from '../../../../../../../../store/slices/contactHomebot'

// Components
import { Text } from '../../../../../../..'
import Step from '../../../../../ModalStepsOutline'

// Assets
import { ConfirmationCheckMark } from '../../../../../../../../svgs/ConfirmationCheckMark'

// Styles
import styles from './ContactConfirmation.module.scss'

export const ContactConfirmation = () => {
  const dispatch = useDispatch()

  const currentStep = useSelector(selectContactHomebotStep)
  const stepIndex = STEPS_CONST.indexOf(currentStep)

  const handleButtonClick = () => {
    dispatch(setContactHomebotDataToInitialState())
    dispatch(setContactHomebotShowModal(false))
  }

  return (
    <Step stepLabel='contact-homebot-contact-confirmation'>
      <Step.HeaderNavSection
        currentStep={currentStep}
        steps={STEPS}
        onCancel={() => dispatch(setContactHomebotShowModal(false))}
        onBack={() =>
          dispatch(setContactHomebotStep(STEPS_CONST[stepIndex - 1]))
        }
      >
        <FormattedMessage
          id='ContactHomebot.confirmation.title'
          defaultMessage='Request sent!'
        />
      </Step.HeaderNavSection>
      <div aria-hidden className={styles.checkMark}>
        <ConfirmationCheckMark />
      </div>
      <Step.Title className={styles.confirmationTitle}>
        <FormattedMessage
          id='ContactHomebotButton.confirmation.step.title'
          defaultMessage='Someone will be in touch shortly!'
        />
      </Step.Title>
      <Step.Body className={styles.confirmationBody}>
        <Text variant='neutralCool' variantCount='700'>
          <FormattedMessage
            id='ContactHomebot.confirmation.step.subtitle'
            defaultMessage='And now all you have to do is wait.'
          />
        </Text>
      </Step.Body>
      <Step.FooterButton onClick={handleButtonClick}>
        <FormattedMessage
          id='ContactHomebot.comments.back.to.listing.button'
          defaultMessage='Back to listing'
        />
      </Step.FooterButton>
    </Step>
  )
}
